import { gql } from '@apollo/client'

export const GQL_QUERY_FAQ_COLLECTION = gql`
  query FaqCollection($id: ID, $code: String) {
    faqCollection(id: $id, code: $code) {
      id
      code
      title
      subtitle
      expandMode
      defaultExpandedIds
      items {
        id
        question
        answer
        order
      }
    }
  }
`
